import { Theme, css } from '@emotion/react';

export const modifierCompactFooter = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const modifierCompactRoot = ({ spacing }: Theme) => css`
  & .quantity {
    display: block;
    height: ${spacing(4.5)}px;
    line-height: ${spacing(4.5)}px;
    text-align: center;
    width: ${spacing(4)}px;
  }

  & .button-row {
    display: inline-flex;
  }
`;
